import { fork, all } from 'redux-saga/effects';

import exampleSaga from 'client/ducks/example/saga';
import routerSaga from 'client/ducks/router/saga';
import appSaga from 'client/ducks/app/saga';
import homepageSaga from 'client/ducks/homepage/saga';
import outreachSaga from 'client/ducks/outreach/saga';
import eventsPageSaga from 'client/ducks/events-page/saga';
import projectsPageSaga from 'client/ducks/projects-page/saga';
import datasetsPageSaga from 'client/ducks/datasets-page/saga';
import newsSaga from 'client/ducks/news/saga';
import publicationSaga from 'client/ducks/publications/saga';
import themeSaga from 'client/ducks/themes/saga';
import researcherSaga from 'client/ducks/researchers/saga';
import searchSaga from 'client/ducks/search/saga';

export default function* rootSaga() {
    yield all([
        fork(exampleSaga),
        fork(routerSaga),
        fork(appSaga),
        fork(homepageSaga),
        fork(outreachSaga),
        fork(eventsPageSaga),
        fork(projectsPageSaga),
        fork(datasetsPageSaga),
        fork(newsSaga),
        fork(publicationSaga),
        fork(themeSaga),
        fork(researcherSaga),
        fork(searchSaga)
    ]);
}
